<template>
  <div class="book">
    <card class="page">
      <el-row :gutter="10">
        <el-col :span="12">
          <h6>{{this.store.storeName}} [{{ this.search.mediaType === 'WC' ? "와이드칼라" : "디지털미디어"}} > {{this.floor.floorType === 'F' ? this.floor.floor + this.floor.floorType : this.floor.floorType + this.floor.floor}}층 : {{this.search.size}}개]</h6>
        </el-col>
        <el-col :span="12">
          <div class="pull-right mb-1">
            <el-button id="printWindowBtn" type="primary" size="small" icon="el-icon-printer" v-if="listType === 'print'" v-on:click="print">프린트</el-button>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24" style="padding-left: 20px">
          <map-component ref="map" :width="610" :read-only="true" :media-type="search.mediaType" :store-seq="search.storeSeq" :store-floor-seq="search.storeFloorSeq" :key="mapComponentKey"></map-component>
        </el-col>
        <el-col :span="24">
          <advertisement-print-component ref="advertisementPrint" :page-type="pageType"></advertisement-print-component>
        </el-col>
      </el-row>
    </card>
  </div>
</template>

<script>
    import Vue from 'vue'
    import {Button, Row, Col, Card} from 'element-ui'
    import StoreProxy from "../../../../proxies/StoreProxy";
    import VueMoment from 'vue-moment'
    import vueNumeralFilterInstaller from 'vue-numeral-filter';
    import MapComponent from "../Common/MapComponent";
    import AdvertisementPrintComponent from "../Common/AdvertisementPrintComponent";

    Vue.use(vueNumeralFilterInstaller)
    Vue.use(VueMoment)
    Vue.use(Button)
    Vue.use(Row)
    Vue.use(Col)
    Vue.use(Card)

    export default {
        name: "StoreStatusPrint",
        created: function () {
            this.search.storeSeq = this.$route.query.storeSeq;
            this.search.storeFloorSeq = this.$route.query.storeFloorSeq;
            this.search.mediaType = this.$route.query.mediaType;
            this.search.sortColumn = this.$route.query.sortColumn;
            this.search.sortOrder = this.$route.query.sortOrder;
            this.search.size = this.$route.query.size;
            this.getStore();
        },
        components: {
            MapComponent,
            AdvertisementPrintComponent,
        },
        methods: {
            // 매장조회
            getStore() {
                new StoreProxy()
                    .find(this.search.storeSeq)
                    .then((response) => {
                        this.store = response.store;
                        let floors = response.storeFloors.filter(function (floor) {
                           return floor.storeFloorSeq === parseInt(this.storeFloorSeq)
                        }, {storeFloorSeq : this.search.storeFloorSeq});
                        if(floors.length > 0) {
                            this.floor = floors[0];
                        }
                        this.$refs.advertisementPrint.getList(this.search);
                    });
            },
            print() {
                this.openedPrintWindow = true
                $('body').addClass('print');
                //$('#printWindowBtn').hide();
                $('#modals-container').remove();
                $('.vue-simple-spinner').parent().remove();

                window.print();


                // 인쇄 대화 상자가 닫힌 후 실행될 콜백 함수를 설정
                this.afterPrintCallback = () => {

                  this.openedPrintWindow = false
                  $('body').removeClass('print')
                  //$('#printWindowBtn').show()

                  console.log("Print dialog has closed!");
                  // 이벤트 리스너 제거
                  window.removeEventListener("focus", this.afterPrintCallback);
                };

                // focus 이벤트에 콜백 함수 연결
                window.addEventListener("focus", this.afterPrintCallback);


            }
        },
        data() {
            return {
                openedPrintWindow: false,
                listType: "print",
                search: {
                    areaSeq: '',
                    mediaType: '',
                    storeSeq: '',
                    storeFloorSeq: 0,
                    sortColumn: '',
                    sortOrder: '',
                },
                pageType: 'storeStatus',
                mapComponentKey: 0,
                store: {},
                floor: {}
            }
        },
    }
</script>

<style scoped>

  body {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    background-color: #FAFAFA;
    font: 12pt "Tahoma";
  }
  * {
    box-sizing: border-box;
    -moz-box-sizing: border-box;
  }
  .page {
    width: 210mm;
    /*min-height: 297mm;*/
    padding: 20mm;
    margin: 10mm auto;
    border: 1px #D3D3D3 solid;
    border-radius: 5px;
    background: white;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  }
  .subpage {
    padding: 1cm;
    border: 5px red solid;
    height: 257mm;
    outline: 2cm #FFEAEA solid;
  }

  @page {
    size: A4;
    margin: 0;
  }
  @media print {
    html, body {
      width: 210mm;
      height: 297mm;
    }
    .page {
      margin: 0;
      border: initial;
      border-radius: initial;
      width: initial;
      min-height: initial;
      box-shadow: initial;
      background: initial;
      page-break-after: always;
    }
  }
  
</style>
